import { Injectable } from '@angular/core';
import {
	RecoverAnswer,
	SecretQuestion,
	TwoFaSetupData,
	TwoFaValidationModel
} from '@models/two-fa.models';
import { MessageService } from '@services/helpers/message-service/message.service';

@Injectable()
export class TwoFaAuthenticationService {
	constructor(private messageService: MessageService) {}

	isTwoFaSetupValid(twoFaData: TwoFaSetupData, setStepFunc: Function) {
		const { sixDigitVerificationCode, secretQuestions } = twoFaData;

		if (
			this.secretQuestionsValid(secretQuestions, setStepFunc) &&
			this.verificationCodeValid(sixDigitVerificationCode)
		) {
			return true;
		}
		return false;
	}

	isTwoFaLoginInfoValid(code: string): boolean {
		return this.verificationCodeValid(code);
	}

	isTwoFaResetDataValid(answers: Array<RecoverAnswer>): boolean {
		return this.isAnswersValid(answers);
	}

	private verificationCodeValid(code: string): boolean {
		if (!code || !code.trim()) {
			this.messageService.showToaster('e_6', 'twoFa');
			return false;
		}

		if (!/^\d+$/.test(code)) {
			this.messageService.showToaster('e_7', 'twoFa');
			return false;
		}

		if (code.length < 6) {
			this.messageService.showToaster('e_5', 'twoFa');
			return false;
		}

		return true;
	}

	private secretQuestionsValid(
		questions: Array<SecretQuestion>,
		setStepFunc: Function
	): boolean {
		const callbackChecker = (question: SecretQuestion): boolean => {
			if (!question.question) {
				this.messageService.showToaster('e_3', 'twoFa');
				return false;
			}

			if (!question.answer || !question.answer.trim()) {
				this.messageService.showToaster('e_0', 'twoFa');
				return false;
			}

			if (question.answer.length <= 1) {
				this.messageService.showToaster('e_2', 'twoFa');
				return false;
			}

			return true;
		};

		if (!questions.every(callbackChecker)) {
			setStepFunc(1);
			return false;
		}

		const questionsMap = new Set();
		questions.forEach((question: SecretQuestion): Set<string> =>
			questionsMap.add(question.answer)
		);

		if (questionsMap.size !== questions.length) {
			this.messageService.showToaster('e_1', 'twoFa');
			setStepFunc(1);
			return false;
		}

		return true;
	}

	private isAnswersValid(answers: Array<RecoverAnswer>): boolean {
		return answers.every((answer: RecoverAnswer): boolean => {
			if (!answer.answer) {
				this.messageService.showToaster('e_0', 'twoFa');
				return false;
			}

			return true;
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/user/two-fa-authentication.service.ts